import { useEffect } from "react";
import { useTheme } from "styled-components";
import { useMediaQuery } from "@ebscois/react-component-library";
import { useLocation } from "react-router-dom";
import {
  NAV_BREAKPOINT,
  CONTENT_OFFSET_MOBILE,
  CONTENT_OFFSET_DESKTOP,
  CONTENT_OFFSET_TABLET
} from "../../../../../utils/constants";

const TAB_BAR_HEIGHT_MOBILE = 1.25;
const TAB_BAR_HEIGHT_DESKTOP = 2.5;

export const selectContentOffset = ({ isDesktop, isTablet, isMobile }) => {
  if (isMobile) return CONTENT_OFFSET_MOBILE;
  if (isTablet) return CONTENT_OFFSET_TABLET;
  if (isDesktop) return CONTENT_OFFSET_DESKTOP;
  return undefined;
};

export default function (shouldWidgetRender) {
  const location = useLocation();
  const theme = useTheme();
  const isDesktop = useMediaQuery("min", NAV_BREAKPOINT); // 1070px +
  const isTablet = useMediaQuery("min", "sm") && !isDesktop; // 640px to 1069px
  const isMobile = !isTablet && !isDesktop; // 0 to 639px

  useEffect(() => {
    if (!shouldWidgetRender) return;

    const content = document.getElementById("main-content");
    const contentContainer = document.getElementById("app-container");
    if (!content || !contentContainer) return;

    const contentOffset = selectContentOffset({
      isDesktop,
      isTablet,
      isMobile
    });
    const tabBarHeight = isMobile
      ? TAB_BAR_HEIGHT_MOBILE
      : TAB_BAR_HEIGHT_DESKTOP;
    const normalizedContentOffset = contentOffset + tabBarHeight;

    content.setAttribute("style", `margin-top: ${normalizedContentOffset}rem`);
    contentContainer.setAttribute(
      "style",
      `
        background: linear-gradient(
      to bottom,
      ${theme.colors.secondary.base} ${normalizedContentOffset}rem,
      ${theme.colors.white} 0
    );
      `
    );
  }, [
    shouldWidgetRender,
    theme,
    isMobile,
    isDesktop,
    isTablet,
    location.pathname
  ]);
}
